import { KeyValue } from '@/main/models/common';

export enum SupplierTypeTypes {
  GET_SUPPLIER_TYPE = '@supplierType/GET_SUPPLIER_TYPE',
  SAVE_SUPPLIER_TYPE = '@supplierType/SAVE_SUPPLIER_TYPE',
  RESET_REDUCER_SUPPLIER_TYPE = '@supplierType/RESET_REDUCER_SUPPLIER_TYPE'
}

export interface SupplierTypeState {
  readonly supplierType: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetSupplierType {
  type: typeof SupplierTypeTypes.GET_SUPPLIER_TYPE;
}

export interface SaveSupplierType {
  type: typeof SupplierTypeTypes.SAVE_SUPPLIER_TYPE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerSupplierType {
  type: typeof SupplierTypeTypes.RESET_REDUCER_SUPPLIER_TYPE;
}

export type SupplierTypeActionTypes =
  | GetSupplierType
  | SaveSupplierType
  | ResetReducerSupplierType;
